module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYBAMAAABpfeIHAAAAJ1BMVEUAAADIhQDKgQAAAADKgADKgAAAAAAnJye6AQC9AwLKgADjHRz/0BgSeI0AAAAABnRSTlMXF87T09XnRNz7AAAAM0lEQVQYV2NgTkMBBgxmqALJDGnlKCCNNgKdu1FAx0AJrDqDAlbRRsBrFQpYxCCKKqAIAMOa8MMB9UiwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flag-de@2x.png
// module id = 504
// module chunks = 9